// @flow
import { DemandasActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    demanda: {},
    listaDemandas: [],
    loading: false,
    error: false,
    formSubmited: false
};

type DemandasAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { demanda?: {} | null, listaDemandas?: [] | null, loading?: boolean, +value ?: boolean };

const Demandas = (state: State = INIT_STATE, action: DemandasAction): any => {
    // console.log('action', action);
    switch (action.type) {
        case DemandasActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case DemandasActionTypes.GET_DEMANDA: {
                    return {
                        ...state,
                        demanda: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case DemandasActionTypes.LIST_DEMANDAS: {
                    return {
                        ...state,
                        listaDemandas: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case DemandasActionTypes.ADD_DEMANDA: {
                    return {
                        ...state,
                        demanda: action.payload.data,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case DemandasActionTypes.UPDATE_DEMANDA: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case DemandasActionTypes.DELETE_DEMANDA: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case DemandasActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case DemandasActionTypes.GET_DEMANDA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        demanda: {},
                        loading: false,
                    };
                }
                case DemandasActionTypes.LIST_DEMANDAS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaDemandas: [],
                        loading: false,
                    };
                }
                case DemandasActionTypes.ADD_DEMANDA: {
                    return {
                        ...state,
                        demanda: {},
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case DemandasActionTypes.UPDATE_DEMANDA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case DemandasActionTypes.DELETE_DEMANDA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case DemandasActionTypes.GET_DEMANDA:
            return { ...state, error: false, loading: true };
        case DemandasActionTypes.LIST_DEMANDAS:
            return { ...state, error: false, loading: true };
        case DemandasActionTypes.ADD_DEMANDA:
            return { ...state, error: false, loading: true };
        case DemandasActionTypes.UPDATE_DEMANDA:
            return { ...state, error: false, loading: true };
        case DemandasActionTypes.DELETE_DEMANDA:
            return { ...state, error: false, loading: true };
        case DemandasActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                demanda: {},
                listaDemandas: [],
                formSubmited: false,
            };
        default:
            return { ...state };
    }
};

export default Demandas;
